import * as React from 'react';
import { useState } from 'react';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { LeaderboardScore } from '../../../components/LeaderboardComponents/LeaderboardScore';
import { isSortOption, SortOptions } from '../../../components/LeaderboardComponents/components/ListHeader';
import { ILeaderboardFilter } from '../../../queries/Leaderboard/criteria';
import { useQueryParameter } from '../../../hooks/query';
import { useLeaderboardQuery } from '../../../queries/Leaderboard';
import { EmptyState } from './EmptyState';
import { Filters } from './Filters';

export const Leaderboard: React.FC = () => {
	const [, sortByParameter, updateSortBy] = useQueryParameter<SortOptions>('sortBy', SortOptions.Demos);
	const [, ascendingParameter, updateAscending] = useQueryParameter<boolean>('asc', false);
	const [filter, setFilter] = useState<ILeaderboardFilter>({});
	// Both come from the URL, so anyone can type anything into them; fall back rather than send it to the API.
	const sortBy = isSortOption(String(sortByParameter)) ? sortByParameter : SortOptions.Demos;
	const asc = String(ascendingParameter) === 'true';

	const { data, isError, isPending } = useLeaderboardQuery({ asc, filter, sortBy });

	if (isPending) {
		return <LoadingSpinner />;
	}

	const leaders = data?.scores ?? [];
	// A failed poll keeps the last good board; only a filter with no answer at all shows the error.
	const emptyState =
		isError && !data ? (
			<EmptyState title="Couldn't load the leaderboard." description='It will try again shortly.' />
		) : leaders.length === 0 ? (
			<EmptyState title='No leaders yet.' description='Make that dial and be the first on the board!' />
		) : null;

	return (
		<LeaderboardScore
			asc={asc}
			renderEmptyState={emptyState}
			renderFilter={<Filters filter={filter} onChange={setFilter} />}
			setAsc={updateAscending}
			setSortBy={updateSortBy}
			sortBy={sortBy}
			top10={leaders}
			totalScores={data}
		/>
	);
};
